import type { TOC } from '@ember/component/template-only';
import SectionPanel from 'tio-ui/components/section-panel';
import type { SummaryGroup } from '../../../utils/tas/program-builder/summary';

interface ReadoutSummaryPanelSignature {
  Args: {
    groups: SummaryGroup[];
  };
  Element: HTMLDivElement;
}

/**
 * Static label/value read-out of `buildSummary` groups — the same content the
 * admin builder's Review step shows, one panel per group. `stacked` groups
 * (long values like approver chains) render the label above the value.
 */
const ReadoutSummaryPanel: TOC<ReadoutSummaryPanelSignature> = <template>
  <div class="space-y-5" ...attributes>
    {{#each @groups as |group|}}
      <SectionPanel
        @icon={{group.icon}}
        @title={{group.title}}
        @iconColor="violet"
        data-test-readout-summary-group={{group.sectionId}}
      >
        <:body>
          {{#if group.stacked}}
            {{#each group.rows as |row|}}
              <div class="py-0.5 text-sm">
                <div class="tio-fg-muted">{{row.label}}</div>
                {{! pre-line keeps paragraph breaks in long text (descriptions,
                disclosures) without affecting single-line approver chains. }}
                <div class="whitespace-pre-line font-medium">{{row.value}}</div>
              </div>
            {{/each}}
          {{else}}
            {{#each group.rows as |row|}}
              <div class="tio-row-between gap-3 py-0.5 text-sm">
                <span class="tio-fg-muted">{{row.label}}</span>
                <span
                  class="text-right font-medium {{if (eq row.value '—') 'tio-fg-faint'}}"
                >{{row.value}}</span>
              </div>
            {{/each}}
          {{/if}}
        </:body>
      </SectionPanel>
    {{/each}}
  </div>
</template>;

export default ReadoutSummaryPanel;
